import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  class: "card custom-shadow rounded-3 bg-white border mb-4 custom-padding-30",
  style: {"padding-bottom":"18px"}
}
const _hoisted_2 = {
  class: "nav nav-tabs gap-2 most-popular-tabs border-0 mb-20",
  id: "myTab",
  role: "tablist"
}
const _hoisted_3 = ["id", "data-bs-target", "aria-controls", "aria-selected", "onClick"]
const _hoisted_4 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_5 = ["id", "aria-labelledby"]
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "position-relative single-play mb-4" }
const _hoisted_8 = { class: "position-absolute bottom-0 start-0 ps-3 pb-3" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "player-container style-two" }
const _hoisted_12 = { class: "fs-14 fw-medium mt-3 mb-2" }
const _hoisted_13 = { class: "d-flex flex-wrap" }
const _hoisted_14 = { class: "fs-12" }
const _hoisted_15 = { class: "d-flex align-items-center ms-4" }
const _hoisted_16 = { class: "d-block fs-12 fw-normal text-body ms-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("div", {
      class: "d-flex justify-content-between align-items-center flex-wrap gap-3 position-relative pb-3",
      style: {"top":"-5px"}
    }, [
      _createElementVNode("h3", { class: "mb-0 fs-18 fw-semibold" }, "Most Popular"),
      _createElementVNode("button", {
        class: "bg-transparent border-0 p-0 d-flex align-items-center text-decoration-none position-relative right-for-rtl text-body",
        style: {"right":"-8px"}
      }, [
        _createElementVNode("span", null, "View All"),
        _createElementVNode("i", { class: "ri-arrow-right-s-line fs-24 position-relative top-1 lh-1 text-body" })
      ])
    ], -1)),
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "nav-item",
          role: "presentation",
          key: tab.id
        }, [
          _createElementVNode("button", {
            class: _normalizeClass(["nav-link bg-border-color rounded-pill fs-12 fw-medium text-body border-0", { active: _ctx.activeTab === tab.id }]),
            id: `${tab.id}-tab`,
            "data-bs-toggle": "tab",
            "data-bs-target": `#${tab.id}-tab-pane`,
            type: "button",
            role: "tab",
            "aria-controls": `${tab.id}-tab-pane`,
            "aria-selected": _ctx.activeTab === tab.id,
            onClick: ($event: any) => (_ctx.setActiveTab(tab.id))
          }, _toDisplayString(tab.label), 11, _hoisted_3)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["tab-pane fade", { 'show active': _ctx.activeTab === tab.id }]),
          key: tab.id,
          id: `${tab.id}-tab-pane`,
          role: "tabpanel",
          "aria-labelledby": `${tab.id}-tab`,
          tabindex: "0"
        }, [
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tab.items, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "col-sm-6 col-md-4",
                key: index
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", {
                    class: "position-relative bg-img rounded-3",
                    style: _normalizeStyle([{
                  backgroundImage: `url(${item.image})`,
                }, {"height":"183px"}])
                  }, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("button", {
                        class: "p-0 border-0 bg-primary rounded-circle audio-play-btn",
                        style: {"width":"44px","height":"44px","line-height":"29px"},
                        onClick: ($event: any) => (_ctx.togglePlayback(index))
                      }, [
                        _createElementVNode("audio", {
                          class: "track",
                          ref_for: true,
                          ref: "audioRefs"
                        }, [
                          _createElementVNode("source", {
                            src: item.audio,
                            type: "audio/mpeg"
                          }, null, 8, _hoisted_10)
                        ], 512),
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", {
                            class: _normalizeClass({
                          'play-pause': true,
                          pause: _ctx.isPlaying === index,
                          play: _ctx.isPlaying !== index,
                        })
                          }, " Play ", 2)
                        ])
                      ], 8, _hoisted_9)
                    ])
                  ], 4),
                  _createElementVNode("h3", _hoisted_12, _toDisplayString(item.title), 1),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("span", _hoisted_14, "By: " + _toDisplayString(item.author), 1),
                    _createElementVNode("div", _hoisted_15, [
                      _cache[0] || (_cache[0] = _createElementVNode("i", { class: "ri-customer-service-line text-primary fs-15 lh-1" }, null, -1)),
                      _createElementVNode("span", _hoisted_16, _toDisplayString(item.plays), 1)
                    ])
                  ])
                ])
              ]))
            }), 128))
          ])
        ], 10, _hoisted_5))
      }), 128))
    ])
  ]))
}